import { render, staticRenderFns } from "./relatorio.vue?vue&type=template&id=1160a423&scoped=true"
import script from "./relatorio.vue?vue&type=script&lang=ts"
export * from "./relatorio.vue?vue&type=script&lang=ts"
import style0 from "./relatorio.vue?vue&type=style&index=0&id=1160a423&prod&lang=scss&scoped=true"
import style1 from "./relatorio.vue?vue&type=style&index=1&id=1160a423&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160a423",
  null
  
)

export default component.exports